import React from 'react'
import styled, {ThemeProvider} from 'styled-components'

import {Box, IconButton, Logo} from '@miro-site/core'
import theme from './theme'

type BackgroundType = keyof typeof theme['background']

const highContrastBgColors: BackgroundType[] = [
  'dark',
  'workshops-color-indigo',
  'workshops-color-blue',
  'workshops-color-red',
]

export interface AcquisitionHeaderProps {
  background?: BackgroundType
  children?: React.ReactNode
}

const headerHeight = {
  height: [68, 92, 92, 92],
}

const Header = styled(Box).attrs<{$background?: string}>(({$background}) => ({
  as: 'header',
  $styles: {
    background: $background,
    position: 'absolute',
    left: 0,
    right: 0,
  },
}))<{$background?: string}>``

const HeaderContainer = styled(Box).attrs({
  $styles: {
    width: [null, null, null, 1680],
    boxSizing: 'content-box',
  },
  $mx: 'auto',
  $px: [20, null, null, 60],
})`
  ${props =>
    props.theme.mq.medium({
      paddingLeft: `${40 / 12}vw`,
      paddingRight: `${40 / 12}vw`,
    })}
`

const HeaderWrapper = styled(Box).attrs({
  $styles: {
    ...headerHeight,
    position: 'relative',
  },
})``

const LogoWrapper = styled(IconButton).attrs({
  $styles: {
    position: 'absolute',
    top: [12, 25, 25, 25],
    left: 0,
  },
})``

const HeaderSpacer = styled(Box).attrs({
  $styles: {
    ...headerHeight,
  },
})``

const AcquisitionHeader: React.FC<AcquisitionHeaderProps> = props => {
  const {background = 'white'} = props

  return (
    <ThemeProvider
      theme={defaultTheme => ({
        ...defaultTheme,
        multipliers: {
          small: value => `${value / 3.65}vw`,
          mediumUp: value => `${value}px`,
          mediumDown: value => `${value / 12}vw`,
          large: value => `${value}px`,
        },
      })}
    >
      <Header $background={theme.background[background]}>
        <HeaderContainer>
          <HeaderWrapper>
            <LogoWrapper
              icon={
                <Logo
                  $styles={{
                    width: 89,
                    height: 32,
                    color: highContrastBgColors.includes(background)
                      ? 'primaryWhite'
                      : 'primaryIndigo',
                  }}
                />
              }
              label="Miro Logo"
              href="/"
              title="Go to the main page"
            />
          </HeaderWrapper>
        </HeaderContainer>
      </Header>
      <HeaderSpacer />
    </ThemeProvider>
  )
}

export default AcquisitionHeader
